"use client";

import * as React from "react";

import classNames from "classnames";

import { LinkButton } from "@stadium/shared/src/components/shared/button";

import { usePlasmicQueryData } from "@stadium/services/plasmic";

import { fetchPlasmicCMSData } from "@stadium/shared/src/helpers/plasmic/cms-api";

import { BE03_TABLE_ID, CMS_FIELDS, CMS_SECTION_FIELDS } from "./constants";

import BlogCardsBase from "@stadium/shared/src/components/plasmic/BlogEntry/blog-cards-base";

import styles from "./main.module.scss";

export interface BE03Props {
  className?: string;
}

const BE03: React.FC<Readonly<BE03Props>> = ({ className }) => {
  const { data, isLoading } = usePlasmicQueryData([BE03_TABLE_ID], async () => {
    const data = await fetchPlasmicCMSData({ tableId: BE03_TABLE_ID });
    if (!data) return null;

    return {
      heading: data[CMS_SECTION_FIELDS.HEADING] || "",
      seeAllText: data[CMS_SECTION_FIELDS.SEE_ALL_TEXT] || "",
      seeAllUrl: data[CMS_SECTION_FIELDS.SEE_ALL_URL] || "",
      cards: (data[CMS_SECTION_FIELDS.CARD] || []).map((item: any) => ({
        image: item[CMS_FIELDS.IMAGE]?.url,
        imageAlt: item[CMS_FIELDS.TITLE] || "",
        category: item[CMS_FIELDS.CATEGORY_TEXT],
        title: item[CMS_FIELDS.TITLE],
        description: item[CMS_FIELDS.DESCRIPTION],
      })),
    };
  });

  if (isLoading) return null;
  if (!data) return null;

  return (
    <section className={classNames(styles.sectionWrapper, className)}>
      <div className={styles.divWrapper}>
        {/* Header */}
        <div className={styles.header}>
          <div className={styles.titleGroup}>
            <h2 className={styles.title}>{data.heading}</h2>
            <span className={styles.titleArrow}></span>
          </div>
          <LinkButton styleType="no-style" href={data.seeAllUrl} className={styles.seeAllLink}>
            <span className={styles.seeAllText}>{data.seeAllText}</span>
            <span className={styles.arrowUpIcon}></span>
          </LinkButton>
        </div>

        {/* Cards */}
        <BlogCardsBase variant="BE03" cards={data.cards} styles={styles} />
      </div>
    </section>
  );
};

export default BE03;
